import React from 'react'
import PropTypes from 'prop-types'
import { getConstant } from 'commons/js/constants'
import { Box, Grid, Cell, Copy } from '@elparking/components'

import ListItem from '../ListItem'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

const CURRENT_COUNTRY_ID = getConstant('COUNTRY_ID')

const NotFound = styled.img`
    max-width: 100%;
`

const List = React.memo(({ items, countryId }) => {
    if (!items.length) {
        return (
            <Box textAlign='center' mt='20px'>
                <NotFound
                  src='/images/booking-process/illus-no-parking.svg' />
                <Box mt='20px'>
                    <Copy dataTest='list-empty-message' fontSize='large' fontWeight='book' padding='0'>
                        <FormattedMessage
                          defaultMessage='No hay parkings Via-T disponibles en esta zona' />
                    </Copy>
                </Box>
            </Box>
        )
    }

    return (
        <Grid
          width='100%'
          columns={['minmax(0, 1fr)', 'minmax(0, 1fr) minmax(0, 1fr)']}
          gridColumnGap='80px'
          gridRowGap='8px'
        >
            {items.map((item, index) => (
                <Cell
                  key={item.id}
                  // IE11 compatibility
                  left={[`1`, `${Math.floor(index % 2) + 1}`]}
                  top={[`${index + 1}`, `${Math.floor(index / 2) + 1}`]}
                >
                    <ListItem
                      item={item}
                      isLinkable={countryId === CURRENT_COUNTRY_ID}
                    />
                </Cell>
            ))}
        </Grid>
    )
})

List.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    countryId: PropTypes.string,
}

export default List
